<template>
    <div class="main">
        <audio  preload="auto" loop="loop" ref="rightMusic">
            <source src="../assets/audio/right-music.mp3">
        </audio>
        <audio  preload="auto" loop="loop" ref="errorMusic">
            <source src="../assets/audio/error-music.mp3">
        </audio>
        <div class="swiper-container swiper-no-swiping">
            <div class="swiper-wrapper">
                <div v-for='(item) in testObj'
                    :key='item.testFlag'
                    class='swiper-slide'
                    :style="{
                        backgroundPosition: `-${itemIndex * 750 / 100}rem 100%`
                    }">
                    <first v-if="item.testFlag === 1"></first>
                    <second v-if="item.testFlag === 2"></second>
                    <third v-if="item.testFlag === 3"></third>
                    <fourth v-if="item.testFlag === 4"></fourth>
                    <fifth v-if="item.testFlag === 5"></fifth>
                    <sixth v-if="item.testFlag === 6"></sixth>
                    <div class="content">
                        <div class="ti-title" :class="[item.testFlag === 6?'kuan':'']">{{item.title}}</div>
                        <transition name="fade">
                        <ul class='test-box'>
                            <li
                                class="ti"
                                @click="getChoose(item,k,i)"
                                :key="i"
                                v-for="(itm,k,i) in item.choose"
                                :style="testStyle(i)"
                                v-show="flag === item.testFlag &&item.testFlag !== 4"
                                :class="[itmIndex === i?'ti-active':'']">
                                <span class="choose-item">{{k}}.&nbsp;&nbsp;&nbsp;</span>
                                <span class="ti-text">{{itm}}</span>
                            </li>
                            <!-- /* eslint-disable no-use-v-if-with-v-for */ -->
                            <li
                                class="ti"
                                @click="manyChoose(itm,idx)"
                                :key="idx"
                                v-for="(itm,idx) in item.choose"
                                :style="testStyle(idx)"
                                v-show="flag === item.testFlag && item.testFlag === 4"
                                ref="teshu"
                                :class="[itm.isChecked?'ti-active':'']">
                                <span class="choose-item">{{itm.key}}.&nbsp;&nbsp;&nbsp;</span>
                                <span class="ti-text">{{itm.value}}</span>
                            </li>
                            <li class="manyTest-btn" @click="nextTest" v-if="item.testFlag === 4">
                                下一题
                            </li>
                        </ul>
                    </transition>
                    </div>
                </div>
            </div>
        </div>
        <!-- 答题提示弹框 -->
        <div class='modal-main identify-box' v-show="discountMoadl">
           <div class="modal-bg"></div>
            <div class='modal-contant'>
                <div class="txt-box">
                        <p class="title pos">{{messageObj.title}}</p>
                        <p :class="[teshutxtStyle?'teshu':'']">{{messageObj.des}}</p>
                    <img class="next-btn swiper-button-next" v-if="noNextBtn" @click="nextFun" src="../assets/img/next_btn.png" alt="">
                    <img class="next-btn" v-else @click="testFinish" src="../assets/img/finish.png" alt="">
                </div>
            </div>
        </div>
        <!-- 答题提示弹框 end-->
        <!-- 最终弹框 -->
         <div class='modal-main identify-box' v-show="resultMoadl">
           <div class="modal-bg"></div>
            <div class='modal-contant'>
                <div class="end-txt-box">
                    <span class="ready-text" :key="i" v-for="(item,i) in resultTex" :style="redayText(i)">{{item}}</span>
                </div>
            </div>
        </div>
        <!--toast-->
        <div class="toast" v-show="toastShow">
            {{toastText}}
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import http from 'axios';
import first from './first';
import second from './second';
import third from './third';
import testObj from '../assets/js/test';
import fourth from './fourth';
import fifth from './fifth';
import sixth from './sixth';
import types from '../store/types';
import services from '../services';

export default {
    components: {
        first,
        second,
        third,
        fourth,
        fifth,
        sixth
    },
    data() {
        return {
            itemIndex: 0,
            flag: 1,
            itmIndex: null,
            resultMoadl: false,
            discountMoadl: false,
            isChooseManyTest: false,
            obj: {},
            testObj: testObj.obj,
            testRightNum: 0,
            noNextBtn: true,
            messageObj: {
                title: '',
                des: ''
            },
            resultTex: '即将算出你在古代夏天能坚持多久…',
            teshutxtStyle: false,
            toastText: '',
            toastShow: false
        };
    },
    mounted() {
        /* eslint-disable no-new */
        new Swiper('.swiper-container', {
            preventLinksPropagation: true,
            pagination: {
                el: '.swiper-pagination'
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    },
    computed: {
        userInfo() {
            return this.$store.state.system.userInfo || {};
        },
        lotteryCount() {
            let num = 0;
            if (this.testRightNum >= 0 && this.testRightNum <= 2) {
                num = 1;
            }
            else if (this.testRightNum === 3) {
                num = 2;
            }
            else if (this.testRightNum >= 4 && this.testRightNum <= 5) {
                num = 3;
            }
            else if (this.testRightNum === 6) {
                num = 4;
            }
            return num;
        }
    },
    methods: {
        testStyle(index) {
            return {
                animationDelay: `${index / 4 + 0.6}s`
            };
        },
        redayText(index) {
            return {
                animationDelay: `${index / 6 + 0.4}s`
            };
        },
        // 单选题
        getChoose(item, key, index) {
            // 获取每道题的提示消息
            this.getMessage(item, key);
            this.itmIndex = index;
            setTimeout(() => {
                this.discountMoadl = true;
                if (item.testFlag === 6) {
                    this.noNextBtn = false;
                }
                else {
                    this.itmIndex = null;
                }
                this.$refs.rightMusic.pause();
                this.$refs.errorMusic.pause();
                this.$refs.rightMusic.currentTime = 0;
                this.$refs.errorMusic.currentTime = 0;
            }, 800);
        },
        // 点击完成按钮
        testFinish() {
            this.discountMoadl = false;
            this.resultMoadl = true;
            setTimeout(() => {
                // this.getLotteryCount();
                Promise.all([
                    this.getLotteryCount(),
                    this.loadFont()
                ]).then(() => {
                    this.$emit('next', 3);
                    this.resultMoadl = false;
                }).catch(e => {
                    console.log(e);
                });
            }, 4500);
        },
        loadFont() {
            return new Promise(resolve => {
                http.get('/font/happy.ttf');
                resolve(true);
            });
        },
        // 获取抽奖次数
        getLotteryCount() {
            return new Promise(resolve => {
                services.getLotteryCount({
                    activity_id: 6,
                    count: this.lotteryCount,
                    userId: this.userInfo.openId,
                    code: `10000_${this.lotteryCount}`
                }).then(res => {
                    if (res && res.returnCode === 0) {
                        this.$store.dispatch(types.summerprize, this.testRightNum);
                        this.$store.dispatch(types.gameNum, res.data.num);
                        resolve(true);
                    }else{
                        this.toast(res.returnMessage);
                        this.resultMoadl = false;
                    }
                }).catch((err) => {
                    console.log(err)
                });
            });
        },
        // 弹框中点击下一题
        nextFun() {
            this.flag++; // 控制显示
            this.itemIndex += 1; // 控制背景
            this.discountMoadl = false;
        },
        // 弹出框提示消息
        getMessage(item, key) {
            if (item.testFlag === 3) {
                this.teshutxtStyle = true;
            }
            else {
                this.teshutxtStyle = false;
            }
            if (key === item.rightChoose) {
                this.messageObj = item.message.right;
                this.$refs.rightMusic.play();
                if (!this.obj[item.order]) {
                    this.obj[item.order] = key;
                    this.testRightNum++;
                }
            }
            else {
                this.messageObj = item.message.error;
                this.$refs.errorMusic.play();
            }
        },
        // 多选题
        manyChoose(item) {
            this.isChooseManyTest = true;
            if (!item.isChecked) {
                item.isChecked = true;
            }
            else {
                item.isChecked = false;
            }
        },
        // 多选点击下一题
        nextTest() {
            if (this.isChooseManyTest) {
                this.testRightNum++;
                this.messageObj = this.testObj.fourth.message.right;
                this.$refs.rightMusic.play();
                setTimeout(() => {
                    this.testObj.fourth.choose.forEach(item => {
                        item.isChecked = false;
                    });
                    this.discountMoadl = true;
                    this.isChooseManyTest = false;
                    this.$refs.rightMusic.pause();
                    this.$refs.rightMusic.currentTime = 0;
                }, 1000);
            }
        },
        // 警示弹框
        toast(str) {
            this.toastText = str;
            this.toastShow = true;
            setTimeout(() => {
                this.toastShow = false;
            }, 1600);
        },

    }
};
</script>

<style lang="stylus" scoped>
@import "../../../../node_modules/swiper/dist/css/swiper.min.css";
.main
    height 100%
    .toast
        position fixed
        z-index 9999
        left 50%
        top 50%
        transition all .5s
        text-align center
        border-radius 5px
        color #FFF
        font-size 0.28rem
        background rgba(17, 17, 17, 0.7)
        padding 0.15rem 0.3rem
        -webkit-transform translateX(-50%) translateY(-50%)
        -moz-transform translateX(-50%) translateY(-50%)
        -ms-transform translateX(-50%) translateY(-50%)
        -o-transform translateX(-50%) translateY(-50%)
        transform translateX(-50%) translateY(-50%)
    .swiper-container,.swiper-wrapper
        height 100%
        .swiper-slide
            position relative
            width 100%
            height 100%
            overflow hidden
            background url("http://wwj.jijiagames.com/web/act/20190702/test_bg.jpg") no-repeat
            .content
                position absolute
                width 5.2rem
                top 50%
                left 50%
                transform translateX(-50%) translateY(-49%)
                z-index 999
            .ti-title
                font-size 0.4rem
                color #fff
                text-align center
                height 1.02rem
                margin-bottom 0.4rem
            .test-box
                .ti
                    z-index 999
                    display flex
                    justify-content center
                    text-align center
                    height 1rem
                    line-height 1rem
                    animation: show 0.5s
                    animation-delay: 0.5s
                    animation-fill-mode: forwards
                    opacity: 0
                    span
                        font-size 0.4rem
                        color #fff
                .ti-active
                    background url("../assets/img/choose.png") 85% center no-repeat
                .manyTest-btn
                    width 1.5rem
                    height 0.6rem
                    font-size 0.3rem
                    color #fff
                    line-height 0.6rem
                    background #ff6666
                    border-radius 8px
                    text-align center
                    margin 0.2rem auto
.swiper-button-next, .swiper-container-rtl .swiper-button-prev
    background none
.swiper-button-next.swiper-button-disabled, .swiper-button-prev.swiper-button-disabled
    opacity 1
@keyframes fadeInOut
    0%
        opacity: 0;
    50%
        opacity: 0.6;
    75%
        opacity: 0.8;
    100%
        opacity: 1;
@keyframes show
    from
        opacity 0
    to
        opacity 1
</style>
